<template>
    <Modal v-model="showDailyModal" width="600" title="修改密码">
        <div style="height: 260px; ">
            <Form ref="form" :model="form" label-position="left" :rules="validate">
                <Row >
                    <Col span="24">
                    <FormItem label="旧密码" prop="oldPassword">
                        <Input type="password" v-model="form.oldPassword" placeholder="请输入旧密码" />
                    </FormItem>
                    </Col>
                </Row>
                <Row >
                    <Col span="24">
                    <FormItem label="新密码" prop="newPassword">
                        <Input type="password" v-model="form.newPassword" placeholder="请输入新密码" />
                    </FormItem>
                    </Col>
                </Row>
                <Row >
                    <Col span="24">
                    <FormItem label="再次输入新密码" prop="newPasswordAgain">
                        <Input type="password" v-model="form.newPasswordAgain" placeholder="请再次输入新密码" />
                    </FormItem>
                    </Col>
                </Row>
            </Form>
        </div>
        <div slot="footer">
            <Button @click="cancleAction">取消</Button>
            <Button type="primary" @click="saveAction">保存</Button>
        </div>
    </Modal>
</template>

<script>
import qs from 'qs'
export default {
    data() {
        return {
            showDailyModal: false,
            form: {
                oldPassword: '',
                newPassword: '',
                newPasswordAgain: ''
            },
            validate: {
                oldPassword: [
                    { required: true, message: "请输入旧密码", trigger: "blur" }
                ],
                newPassword: [
                    { required: true, message: "请输入新密码", trigger: "blur" }
                ],
                newPasswordAgain: [
                    { required: true, message: "请再次输入新密码", trigger: "change" }
                ]
            }
        }
    },
    methods: {
        // 显示modal
        showModalView() {
            this.form.oldPassword='';
            this.form.newPassword='';
            this.form.newPasswordAgain='';
            this.showDailyModal = true;
        },
        // 取消
        cancleAction() {
            //清空数据
            if (this.formInline !== null) {
                Object.keys(this.form).forEach((key) => (this.form[key] = ''))
            }
            this.showDailyModal = false;
        },
        // 保存
        saveAction() {
            if(this.form.newPassword!=this.form.newPasswordAgain){
                this.$Message.warning('新密码两次输入不一致')
                return;
            }
            this.axios.post('/webapi/web/modifypassword', qs.stringify({
                oldpwd: this.form.oldPassword,
                newpwd: this.form.newPassword
            }))
                .then(res => {
                    let data = res.data
                    if (data.code === 200) {
                        this.$Message.success(data.msg)
                        this.showDailyModal = false;
                    } else {
                        this.$Message.error(data.msg)
                    }
                })
        },
    }
}
</script>

<style lang="less" scoped></style>